import BaseServices from "./BaseServices";

const BankingServices = {
    AdminHookSMS: async (model) => {
        return await BaseServices.Post("/api/Banking/admin-hook-sms", model);
    },
};

export default BankingServices;
